import React, { useState, useRef } from "react";

const UploadMessage = ({ Question, onUpload, chatContainerRef, isEdit }) => {
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploading, setUploading] = useState(false);
    const [isFileUploaded, setIsFileUploaded] = useState(false);
    const [fileName, setFileName] = useState("");
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");

    const handleFileButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            // ✅ Allowed formats: JPEG, JPG, PNG, PDF
            const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
            const fileSizeMB = file.size / (1024 * 1024); // Convert bytes to MB

            if (!allowedTypes.includes(file.type)) {
                setErrorMessage("❌ Invalid file type! Only JPEG, JPG, PNG, and PDF are allowed.");
                setTimeout(() => {
                    setErrorMessage("");
                }, 3000);
                return;
            }

            if (fileSizeMB > 10) {
                setErrorMessage("❌ File is too large! Max file size is 10MB.");
                setTimeout(() => {
                    setErrorMessage("");
                }, 3000);
                return;
            }

            setErrorMessage("");
            setFileName(file.name);
            setSelectedFile(file);
            setUploading(true);
            simulateUpload();
        }
    };

    const simulateUpload = () => {
        const totalChunks = 100;
        let uploadedChunks = 0;

        const interval = setInterval(() => {
            if (uploadedChunks < totalChunks) {
                uploadedChunks += 10;
                setUploadProgress(uploadedChunks);
            } else {
                clearInterval(interval);
                setUploading(false);
                setIsFileUploaded(true);
            }
        }, 500);
    };

    const handleSubmit = () => {
        if (isFileUploaded && selectedFile) {
            onUpload(fileName, selectedFile); // Send to `ChatSection.js`
        }
        // ✅ Scroll Chat Window to Bottom After Message Submission
        setTimeout(() => {
            if (chatContainerRef?.current) {
                chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
            }
        }, 100); // ✅ Small delay to allow UI update before scrolling
    };

    return (
        <div className="left-chatbot-message-section">
            {isEdit && (
            <div className="input-type-text-response-title">
                {Question}          
            </div>
            )}
            <div className="input-type-text-response">
                <div className="input-type-text-response-content">
                    <div className="input-type-text-response-content-option">
                        {/* ✅ Show error message if file is invalid */}
                        {errorMessage && <div className="error-message">{errorMessage}</div>}

                        {/* Show upload progress if uploading, else show file input */}
                        {!uploading && !isFileUploaded ? (
                            <>
                                <input
                                    type="file"
                                    className="custom-input-file"
                                    ref={fileInputRef}
                                    onChange={handleFileChange}
                                    style={{ display: "none" }}
                                />
                                <label
                                    className="custom-file-upload"
                                    onClick={handleFileButtonClick}
                                >
                                    <img
                                        src="/images/document-upload-icon.png"
                                        alt="upload-icon"
                                    />
                                    {!isEdit ? Question : "Select"}
                                </label>
                            </>
                        ) : (
                            <div className="upload-progress-container">
                                
                                <div className="upload-progress">
                                    <div className="upload-progress-heading">
                                        <img src="/images/pdf-icon.png" alt="pdf-icon"/>
                                        <div className="file-name">{fileName}</div>
                                        <div className="cancel-button">
                                            <img src="/images/upload-cancel-button.png" alt="cancel-button"/>
                                     </div>
                                    </div>

                                    <div className="upload-progress-report">
                                    <div
                                        className="upload-progress-bar"
                                        style={{ width: `${uploadProgress}%` }}
                                    ></div>
                                 </div>
                                 
                                </div>
                                
                            </div>
                        )}
                    </div>

                    {/* Chat response button */}
                    <div className="chat-response-button" onClick={handleSubmit}>
                        <img
                            src={
                                isFileUploaded
                                    ? "/images/message-send-active-icon.png"
                                    : "/images/message-send-disabled-icon.png"
                            }
                            alt="message-send-icon"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UploadMessage;
